import { type Translate } from 'react-admin';
import { z } from 'zod';

export function getChangePasswordFormValidationSchema(translate: Translate) {
  const zodSchema = z
    .object({
      oldPassword: z
        .string()
        .min(1, translate('resources.settings.change_password_form.required_field')),
      password: z
        .string()
        .min(1, translate('resources.settings.change_password_form.required_field')),
      confirmPassword: z
        .string()
        .min(1, translate('resources.settings.change_password_form.required_field')),
    })
    .refine(data => data.password === data.confirmPassword, {
      message: translate('resources.settings.change_password_form.errors.password_doesnt_match'),
      path: ['confirmPassword'],
    });

  return zodSchema;
}
